import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { MdLocationOn } from 'react-icons/md';
import { formatTimeInTimezone } from 'pages/utils/formdatedynamics';
import { getReadableOrderId } from 'pages/utils/HelperFun';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';

const getOrderDetails = (data) => data?.orderDetails || {};

const getOrderNumber = (data, prefix = 'WS') => {
    if (!data?._id) return `${prefix}-—`;
    return getReadableOrderId(String(data._id), prefix);
};

export const getLocationName = (data, fallback = 'Location not provided') => {
    const location =
        data?.shopLocationText ||
        data?.shopLocation?.display_name ||
        data?.shopLocation?.text ||
        data?.serviceLocation?.display_name ||
        data?.serviceLocation?.text ||
        data?.location?.display_name ||
        data?.location?.text ||
        data?.shopId?.location?.display_name ||
        data?.shopId?.location?.text;

    return location || fallback;
};

const getVehicleName = (data) => {
    const manufacturer = data?.vehicleId?.vehicleManufacturer || '';
    const name = data?.vehicleId?.vehicleName || '';
    return `${manufacturer} ${name}`.trim() || 'Vehicle';
};

const getVehicleType = (data) => data?.vehicleId?.vehicleType || '';

const getVehicleSubtitle = (data) => {
    const parts = [
        data?.vehicleId?.vehicleType,
        data?.vehicleId?.vehicleColor,
        data?.vehicleId?.color,
    ].filter(Boolean);

    return parts.join(' · ');
};

// const formatDateTimeLabel = (value) => {
//     if (!value) return '—';
//     const date = new Date(value);
//     if (Number.isNaN(date.getTime())) return '—';
//     const dateLabel = new Intl.DateTimeFormat('en-GB', {
//         day: 'numeric',
//         month: 'long',
//         year: 'numeric',
//     }).format(date);

//     return `${dateLabel} · ${formatTimeInTimezone(value)}`;
// };
const formatDateTimeLabel = (value) => {
    if (!value) return '—';

    const local = moment.utc(value).local();
    if (!local.isValid()) return '—';

    return `${local.format('D MMMM YYYY')} · ${local.format('hh:mm A')}`;
};


export const WASHTA_COMMISSION_PERCENT = 0;

// export const getOrderPricing = (data) => {
//     const orderDetails = getOrderDetails(data);

//     const cost = parseFloat(data?.cost || 0);
//     const finalCost = parseFloat(data?.finalCost ?? cost);
//     const addOnsTotal = Number(orderDetails.addOnsTotal ?? data?.addOnsTotal ?? 0);
//     const discount = parseFloat(data?.discount || 0);

//     // Customer-facing total (what the customer paid)
//     const customerTotal = Number((finalCost + addOnsTotal - discount).toFixed(2));

//     // Seller payout (what Washta pays the seller, after commission %)
//     const servicePrice = Number(data?.cost ?? data?.finalCost ?? 0);
//     const washtaCommission = Number(((servicePrice * WASHTA_COMMISSION_PERCENT) / 100).toFixed(2));
//     const sellerReceives = Number((servicePrice - washtaCommission + addOnsTotal - discount).toFixed(2));

//     return {
//         cost,
//         finalCost,
//         addOnsTotal,
//         discount,
//         customerTotal,
//         servicePrice,
//         washtaCommission,
//         sellerReceives,
//     };
// };

// export const getOrderPricing = (data) => {
//     const orderDetails = getOrderDetails(data);

//     const cost = parseFloat(data?.cost || 0);
//     const finalCost = parseFloat(data?.finalCost ?? cost);
//     const addOnsTotal = Number(orderDetails.addOnsTotal ?? data?.addOnsTotal ?? 0);
//     const discount = parseFloat(data?.discount || 0);

//     // finalCost already includes addOns - discount (backend computes this).
//     // Customer-facing total = finalCost as-is, no need to add addOnsTotal again.
//     const customerTotal = Number(finalCost.toFixed(2));

//     // Seller payout (Washta pays seller after commission %)
//     const servicePrice = Number(data?.cost ?? data?.finalCost ?? 0);
//     const washtaCommission = Number(((servicePrice * WASHTA_COMMISSION_PERCENT) / 100).toFixed(2));
//     const sellerReceives = Number((finalCost - washtaCommission).toFixed(2));

//     return {
//         cost,
//         finalCost,
//         addOnsTotal,
//         discount,
//         customerTotal,
//         servicePrice,
//         washtaCommission,
//         sellerReceives,
//     };
// };
export const getOrderPricing = (data) => {
    const orderDetails = getOrderDetails(data);

    const cost = parseFloat(data?.cost || 0);
    const finalCost = parseFloat(data?.finalCost ?? cost);
    const addOnsTotal = Number(orderDetails.addOnsTotal ?? data?.addOnsTotal ?? 0);
    const discount = parseFloat(data?.discount || 0);
    const servicePrice = Number((data?.cost ?? data?.finalCost ?? 0));

    // const customerTotal = Number((servicePrice + addOnsTotal - discount).toFixed(2));
    const customerTotal = Number((servicePrice + addOnsTotal).toFixed(2));

    const washtaCommission = Number(((servicePrice * WASHTA_COMMISSION_PERCENT) / 100).toFixed(2));
    // const sellerReceives = Number((servicePrice + addOnsTotal - discount - washtaCommission).toFixed(2));
    const sellerReceives = Number((servicePrice + addOnsTotal  - washtaCommission).toFixed(2));

    return {
        cost,
        finalCost,
        addOnsTotal,
        discount,
        customerTotal,
        servicePrice,
        washtaCommission,
        sellerReceives,
    };
};
const STATUS_PILL = {
    ongoing:           { bg: '#fff3cd', color: '#856404', label: 'ONGOING' },
    inprocess:         { bg: '#cce5ff', color: '#004085', label: 'IN PROCESS' },
    completed:         { bg: '#d4edda', color: '#155724', label: 'COMPLETED' },
    cancelled:         { bg: '#e2e3e5', color: '#495057', label: 'CANCELLED' },
    refunded:          { bg: '#f3e8ff', color: '#5b21b6', label: 'REFUNDED' },
    'expired (system)':{ bg: '#e2e3e5', color: '#495057', label: 'EXPIRED' },
};

const StatusPill = ({ status }) => {
    const s = STATUS_PILL[status?.toLowerCase()] || STATUS_PILL.completed;
    return (
        <span style={{
            fontSize: '9px', fontWeight: '700', padding: '3px 9px', borderRadius: '100px',
            background: s.bg, color: s.color, whiteSpace: 'nowrap', letterSpacing: '.05em',
        }}>
            {s.label}
        </span>
    );
};

// Who actioned this order at its current stage — Admin if the matching *ByAdmin
// flag is set, otherwise the provider handled it themselves.
const ADMIN_ACTION_COLORS = {
    Cancelled: { bg: '#fee2e2', color: '#991b1b' },
    Completed: { bg: '#d1fae5', color: '#065f46' },
    Accepted: { bg: '#dbeafe', color: '#1e40af' },
};

const getActionActor = (data) => {
    const status = String(data?.status || '').toLowerCase();
    if (status === 'cancelled') return { verb: 'Cancelled', byAdmin: !!data?.cancelledByAdmin };
    if (status === 'completed') return { verb: 'Completed', byAdmin: !!data?.completedByAdmin };
    if (status === 'inprocess') return { verb: 'Accepted', byAdmin: !!data?.acceptedByAdmin };
    return null;
};

const AdminActionBadge = ({ data }) => {
    const action = getActionActor(data);
    if (!action) return null;
    const colors = ADMIN_ACTION_COLORS[action.verb];
    return (
        <span style={{
            fontSize: '8px', fontWeight: '700', padding: '2px 7px', borderRadius: '100px',
            background: colors.bg, color: colors.color, whiteSpace: 'nowrap',
        }}>
            {action.verb} by {action.byAdmin ? 'Admin' : 'Provider'}
        </span>
    );
};

const PaidPill = ({ isPaid }) => (
    <span style={{
        fontSize: '9px', fontWeight: '700', padding: '3px 9px', borderRadius: '100px',
        background: isPaid ? '#e8f5e9' : '#fef2f2',
        color: isPaid ? '#1b5e20' : '#b91c1c',
        border: isPaid ? '1px solid #c8e6c9' : '1px solid #fca5a5',
        whiteSpace: 'nowrap',
    }}>
        {isPaid ? '✓ PAID' : 'UNPAID'}
    </span>
);

// ── ACTIVE ORDER CARD (prominent horizontal layout) ────────────────────────────
export const ActiveOrderCard = ({ data, Accpet, Refuse, Complete, billingStatus, status, orderlocation, showMarkButton = true, onViewDetails }) => {
    const [loadingAction, setLoadingAction] = useState(null);
    const orderDetails = getOrderDetails(data);

    const isExpired = data?.isExpired;
    const displayStatus = status === 'ongoing' && isExpired ? 'expired (system)' : status;

    const serviceName = orderDetails.service || data?.serviceVariant?.variantName || data?.carServiceName || 'Service';
    const variantTypeLabel = orderDetails.variantTypeLabel || data?.serviceVariant?.variantTypeLabel || '';
    const isMobileService = (orderDetails.variantType || data?.serviceVariant?.variantType) === 'mobile';
    const parkingPrompt = orderDetails.parkingPrompt || data?.serviceVariant?.parkingPrompt || '';
    const locationLabel = getLocationName(data, orderlocation);

    // Active orders still show the customer-facing total (nothing to pay out yet)
    const { customerTotal } = getOrderPricing(data);
    const displayTotal = customerTotal.toFixed(2);

    const handleAction = async (actionType, actionFn) => {
        setLoadingAction(actionType);
        try { await actionFn(); } catch (e) { console.error(e); } finally { setLoadingAction(null); }
    };

    const orderId = getOrderNumber(data, 'ORD');
    const vehicle = getVehicleName(data);
    const vehicleType = getVehicleType(data);
    const plate = data?.vehicleId?.vehiclePlateNumber || 'PLATE';

    return (
        <div style={{
            border: '1px solid #f5b5b5', borderRadius: '12px', background: '#fffafa',
            padding: '14px', marginBottom: '10px', display: 'flex', alignItems: 'flex-start', gap: '14px',
        }}>
            {/* LEFT */}
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '10px', color: '#888', fontWeight: '600', marginBottom: '3px', fontFamily: 'monospace' }}>
                    {orderId}
                </div>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#111', marginBottom: '6px' }}>
                    {locationLabel}
                </div>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '10px', color: '#666', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        🚗 {vehicle}
                    </span>
                    <span style={{
                        fontSize: '9px', fontWeight: '700', background: '#fff9c4', color: '#5c4a00',
                        border: '1px solid #ffe082', borderRadius: '4px', padding: '1px 6px',
                    }}>{plate}</span>
                    <span style={{ fontSize: '10px', color: '#666' }}>
                        🧴 {serviceName}{variantTypeLabel ? ` · ${variantTypeLabel}` : ''}{vehicleType ? ` · ${vehicleType}` : ''}
                    </span>
                </div>

                {/* Parking badge — mobile only */}
                {isMobileService && data?.carParkedAt && (
                    <div style={{
                        marginTop: '10px', display: 'inline-flex', alignItems: 'center', gap: '7px',
                        background: '#fff3cd', border: '1px solid #ffe082', borderRadius: '8px', padding: '6px 12px',
                    }}>
                        <span style={{ fontSize: '14px' }}>🅿️</span>
                        <div>
                            <div style={{ fontSize: '9px', fontWeight: '700', color: '#856404', textTransform: 'uppercase', letterSpacing: '.05em' }}>Parked at</div>
                            <div style={{ fontSize: '12px', fontWeight: '700', color: '#5c4a00' }}>{data.carParkedAt}</div>
                        </div>
                    </div>
                )}
                {isMobileService && !data?.carParkedAt && parkingPrompt && (
                    <div style={{
                        marginTop: '8px', display: 'inline-flex', alignItems: 'center', gap: '7px',
                        background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '8px', padding: '6px 12px',
                    }}>
                        <span style={{ fontSize: '14px' }}>🅿️</span>
                        <div>
                            <div style={{ fontSize: '9px', fontWeight: '700', color: '#c2410c', textTransform: 'uppercase' }}>Parking note</div>
                            <div style={{ fontSize: '12px', fontWeight: '700', color: '#9a3412' }}>{parkingPrompt}</div>
                        </div>
                    </div>
                )}

                {/* <div style={{ marginTop: '8px', fontSize: '10px', color: '#888', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <MdLocationOn size={11} />
                    {data?.location?.display_name || data?.location?.text || orderlocation}
                </div> */}
            </div>

            {/* RIGHT */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'flex-end', flexShrink: 0 }}>
                <StatusPill status={displayStatus} />
                <PaidPill isPaid={data?.isPaid} />
                <AdminActionBadge data={data} />
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#111' }}>{displayTotal} AED</div>

                {/* Action buttons */}
                {status === 'ongoing' && !isExpired ? (
                    <div style={{ display: 'flex', gap: '6px', marginTop: '2px' }}>
                        <button
                            onClick={() => handleAction('refuse', Refuse)}
                            disabled={loadingAction !== null}
                            style={{
                                fontSize: '10px', fontWeight: '700', padding: '6px 10px',
                                background: '#fff', color: '#ef4444', border: '1px solid #fca5a5',
                                borderRadius: '8px', cursor: 'pointer',
                            }}
                        >
                            {loadingAction === 'refuse' ? <CircularProgress size={14} color="inherit" /> : 'Refuse'}
                        </button>
                        <button
                            onClick={() => handleAction('accept', Accpet)}
                            disabled={loadingAction !== null}
                            style={{
                                fontSize: '10px', fontWeight: '700', padding: '6px 14px',
                                background: '#6B5FE4', color: '#fff', border: 'none',
                                borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap',
                            }}
                        >
                            {loadingAction === 'accept' ? <CircularProgress size={14} color="inherit" /> : 'Accept →'}
                        </button>
                    </div>
                ) : showMarkButton && !isExpired ? (
                    <button
                        onClick={() => handleAction('complete', Complete)}
                        disabled={loadingAction !== null}
                        style={{
                            fontSize: '10px', fontWeight: '700', padding: '6px 14px',
                            background: '#6B5FE4', color: '#fff', border: 'none',
                            borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap', marginTop: '2px',
                        }}
                    >
                        {loadingAction === 'complete' ? <CircularProgress size={14} color="inherit" /> : 'Mark Complete →'}
                    </button>
                ) : null}

                <button
                    onClick={onViewDetails}
                    style={{
                        fontSize: '10px', color: '#6B5FE4', padding: '4px 10px',
                        border: '1px solid #d8d2ff', borderRadius: '6px', cursor: 'pointer',
                        background: '#fff', whiteSpace: 'nowrap',
                    }}
                >
                    Details
                </button>
            </div>
        </div>
    );
};

// ── COMPLETED ORDER — LIST ROW ─────────────────────────────────────────────────
export const CompletedOrderRow = ({ data, billingStatus, status, orderlocation, onViewDetails }) => {
    const orderDetails = getOrderDetails(data);
    const serviceName = orderDetails.service || data?.serviceVariant?.variantName || data?.carServiceName || 'Service';
    const isMobileService = (orderDetails.variantType || data?.serviceVariant?.variantType) === 'mobile';
    const parkingNote = data?.carParkedAt || orderDetails.parkingPrompt || data?.serviceVariant?.parkingPrompt || '';
    const locationLabel = getLocationName(data, orderlocation);
    const vehicle = getVehicleName(data);
    const plate = data?.vehicleId?.vehiclePlateNumber || 'PLATE';
    const orderId = getOrderNumber(data, 'WS');

    // Completed orders show seller payout (same formula as the modal: cost - Washta % + addOns - discount)
    const { sellerReceives } = getOrderPricing(data);
    const displayTotal = sellerReceives.toFixed(2);

    // const timeStr = data?.paidAt
    //     ? new Date(data.paidAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
    //     : data?.date ? new Date(data.date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : '—';
const timeStr = data?.paidAt
  ? moment.utc(data.paidAt).local().format('hh:mm A')
  : data?.date
    ? moment.utc(data.date).local().format('hh:mm A')
    : '—';
    return (
        <tr style={{ borderBottom: '1px solid #f5f5f7', cursor: 'pointer' }}
            onMouseEnter={e => e.currentTarget.style.background = '#faf9ff'}
            onMouseLeave={e => e.currentTarget.style.background = ''}
        >
            <td style={{ padding: '10px', fontSize: '11px', color: '#444', verticalAlign: 'middle' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', color: '#6B5FE4', fontFamily: 'monospace' }}>
                    {orderId}
                </div>
            </td>
            <td style={{ padding: '10px', fontSize: '11px', color: '#444', verticalAlign: 'middle' }}>
                <div style={{ fontSize: '11px', fontWeight: '600', color: '#111' }}>{locationLabel}</div>
                <div style={{ fontSize: '9px', color: '#bbb', marginTop: '1px' }}>{isMobileService ? 'Mobile' : 'Stationed'}</div>
            </td>
            <td style={{ padding: '10px', fontSize: '11px', color: '#444', verticalAlign: 'middle' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span>{vehicle}</span>
                    <span style={{ fontSize: '9px', fontWeight: '700', background: '#fff9c4', color: '#5c4a00', border: '1px solid #ffe082', borderRadius: '4px', padding: '1px 6px' }}>
                        {plate}
                    </span>
                </div>
            </td>
            <td style={{ padding: '10px', fontSize: '11px', color: '#444', verticalAlign: 'middle' }}>
                <div style={{ fontSize: '10px', color: '#6B5FE4', fontWeight: '600' }}>{serviceName}</div>
                {isMobileService && parkingNote && (
                    <div style={{ fontSize: '9px', color: '#856404', background: '#fff9e6', border: '1px solid #ffe082', borderRadius: '4px', padding: '1px 5px', marginTop: '3px', display: 'inline-block' }}>
                        🅿️ {parkingNote}
                    </div>
                )}
            </td>
            <td style={{ padding: '10px', fontSize: '10px', color: '#888', verticalAlign: 'middle' }}>
                {timeStr}
            </td>
            <td style={{ padding: '10px', fontSize: '11px', fontWeight: '700', color: '#111', verticalAlign: 'middle' }}>
                {displayTotal} AED
            </td>
            <td style={{ padding: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                    <StatusPill status={status} />
                    <PaidPill isPaid={data?.isPaid} />
                </div>
            </td>
            <td style={{ padding: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
                <AdminActionBadge data={data} />
            </td>
            <td style={{ padding: '10px', textAlign: 'right', verticalAlign: 'middle' }}>
                <button
                    onClick={onViewDetails}
                    style={{
                        fontSize: '10px', color: '#6B5FE4', padding: '4px 10px',
                        border: '1px solid #d8d2ff', borderRadius: '6px', cursor: 'pointer',
                        background: '#fff', whiteSpace: 'nowrap',
                    }}
                >
                    Details
                </button>
            </td>
        </tr>
    );
};

// ── COMPLETED ORDER — CARD (grid view) ────────────────────────────────────────
export const CompletedOrderCard = ({ data, billingStatus, status, orderlocation, onViewDetails }) => {
    const orderDetails = getOrderDetails(data);
    const serviceName = orderDetails.service || data?.serviceVariant?.variantName || data?.carServiceName || 'Service';
    const isMobileService = (orderDetails.variantType || data?.serviceVariant?.variantType) === 'mobile';
    const parkingNote = data?.carParkedAt || orderDetails.parkingPrompt || data?.serviceVariant?.parkingPrompt || '';
    const locationLabel = getLocationName(data, orderlocation);
    const vehicle = getVehicleName(data);
    const plate = data?.vehicleId?.vehiclePlateNumber || 'PLATE';
    const orderId = getOrderNumber(data, 'WS');

    // Completed orders show seller payout (same formula as the modal: cost - Washta % + addOns - discount)
    const { sellerReceives } = getOrderPricing(data);
    const displayTotal = sellerReceives.toFixed(2);

    // const timeStr = data?.paidAt
    //     ? new Date(data.paidAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
    //     : '—';
 const timeStr = data?.paidAt
  ? moment.utc(data.paidAt).local().format('hh:mm A')
  : data?.date
    ? moment.utc(data.date).local().format('hh:mm A')
    : '—';

    return (
        <div
            style={{
                border: '1px solid #e8e8ec', borderRadius: '12px', padding: '14px', background: '#fff', cursor: 'pointer',
                transition: 'border-color .15s, background .15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#c9c0ff'; e.currentTarget.style.background = '#faf9ff'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#e8e8ec'; e.currentTarget.style.background = '#fff'; }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: '#111' }}>{locationLabel}</div>
                    <div style={{ fontSize: '9px', color: '#aaa', fontFamily: 'monospace', marginTop: '2px' }}>{orderId} · {timeStr}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                    <StatusPill status={status} />
                    <PaidPill isPaid={data?.isPaid} />
                    <AdminActionBadge data={data} />
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ fontSize: '10px', color: '#666', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    🚗 {vehicle}
                    <span style={{ fontSize: '9px', fontWeight: '700', background: '#fff9c4', color: '#5c4a00', border: '1px solid #ffe082', borderRadius: '4px', padding: '1px 5px' }}>{plate}</span>
                </div>
                <div style={{ fontSize: '10px', color: '#666', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    🧴 <span style={{ color: '#6B5FE4', fontWeight: '600' }}>{serviceName}</span>
                    <span style={{ color: '#aaa', fontSize: '9px' }}>· {isMobileService ? 'Mobile' : 'Stationed'}</span>
                </div>
                {isMobileService && parkingNote && (
                    <div style={{ fontSize: '9px', color: '#856404', background: '#fff9e6', border: '1px solid #ffe082', borderRadius: '4px', padding: '2px 6px', display: 'inline-block', alignSelf: 'flex-start' }}>
                        🅿️ {parkingNote}
                    </div>
                )}
                <div style={{ fontSize: '14px', fontWeight: '700', color: '#111', marginTop: '4px' }}>{displayTotal} AED</div>
            </div>
            <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'flex-end' }}>
                <button
                    onClick={onViewDetails}
                    style={{ fontSize: '10px', color: '#6B5FE4', padding: '4px 10px', border: '1px solid #d8d2ff', borderRadius: '6px', cursor: 'pointer', background: '#fff' }}
                >
                    View Details
                </button>
            </div>
        </div>
    );
};

// ── ORDER DETAIL MODAL ─────────────────────────────────────────────────────────
export const OrderDetailModal = ({ visible, onHide, data, billingStatus, status, orderlocation, onMarkComplete, onAccept, onRefuse }) => {
    const [loadingAction, setLoadingAction] = useState(null);
    if (!data) return null;
console.log('dasdasdasd',data)
    const orderDetails = getOrderDetails(data);
    const isExpired = data?.isExpired;
    const displayStatus = status === 'ongoing' && isExpired ? 'expired (system)' : status;

    const serviceName = orderDetails.service || data?.serviceVariant?.variantName || data?.carServiceName || 'Service';
    const variantTypeLabel = orderDetails.variantTypeLabel || data?.serviceVariant?.variantTypeLabel || '';
    const isMobileService = (orderDetails.variantType || data?.serviceVariant?.variantType) === 'mobile';
    const parkingNote = data?.carParkedAt || orderDetails.parkingPrompt || data?.serviceVariant?.parkingPrompt || '';
    const locationName = getLocationName(data, orderlocation);
    const vehicleName = getVehicleName(data);
    const vehicleSubtitle = getVehicleSubtitle(data);

    const addOns = Array.isArray(orderDetails.addOns) ? orderDetails.addOns : (Array.isArray(data?.selectedAddOns) ? data.selectedAddOns : []);
    const orderId = getOrderNumber(data, 'WS');
    const isRefunded = status?.toLowerCase() === 'refunded';
    const lowerStatus = String(status || '').toLowerCase();
    const canComplete = lowerStatus === 'inprocess' && !isExpired && typeof onMarkComplete === 'function';
    const canAcceptRefuse = lowerStatus === 'ongoing' && !isExpired;

    // Shared pricing — identical formula used in CompletedOrderRow / CompletedOrderCard
    const {
        addOnsTotal,
        discount,
        servicePrice,
        washtaCommission,
        sellerReceives,
    } = getOrderPricing(data);

    const rowStyle = { display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #eef0f4', gap: '14px' };
    const labelStyle = { fontSize: '12px', color: '#8d8d8d', flexShrink: 0 };
    const valStyle = { fontSize: '12px', fontWeight: '700', color: '#1a1a1a', textAlign: 'right' };

    const handleMarkComplete = async () => {
        setLoadingAction('complete');
        try {
            await onMarkComplete?.();
            onHide?.();
        } catch (error) {
            console.error('Failed to mark complete:', error);
        } finally {
            setLoadingAction(null);
        }
    };
    const handleAccept = async () => {
        setLoadingAction('accept');
        try {
            await onAccept?.();
            onHide?.();
        } catch (error) {
            console.error('Failed to accept:', error);
        } finally {
            setLoadingAction(null);
        }
    };

    const handleRefuse = async () => {
        setLoadingAction('refuse');
        try {
            await onRefuse?.();
            onHide?.();
        } catch (error) {
            console.error('Failed to refuse:', error);
        } finally {
            setLoadingAction(null);
        }
    };
    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px', width: '100%' }}>
                    <div>
                        <div style={{ fontSize: '22px', fontWeight: '700', color: '#171717', lineHeight: 1.1 }}>Order Details</div>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#6B5FE4', marginTop: '4px', fontFamily: 'monospace' }}>{orderId}</div>
                    </div>
                    <button
                        type="button"
                        onClick={onHide}
                        aria-label="Close"
                        style={{
                            width: '52px',
                            height: '52px',
                            borderRadius: '999px',
                            border: 'none',
                            background: '#f1f1f4',
                            color: '#9a9a9a',
                            fontSize: '34px',
                            lineHeight: 1,
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        ×
                    </button>
                </div>
            }
            style={{ width: '95vw', maxWidth: '760px', borderRadius: '28px', border: 'none' }}
            maskStyle={{ backgroundColor: 'rgba(17,17,34,0.55)', backdropFilter: 'blur(8px)', zIndex: 1100 }}
            headerStyle={{ background: '#f7f7f9', padding: '14px 20px 12px', borderBottom: '1px solid #eee', borderTopLeftRadius: '28px', borderTopRightRadius: '28px' }}
            contentStyle={{ padding: 0 }}
            closable={false}
            modal
            draggable={false}
        >
            <div style={{ background: '#fff' }}>
                <div style={{ padding: '16px 20px 12px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div>
                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.12em', marginBottom: '8px' }}>Status</div>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <StatusPill status={displayStatus} />
                            <PaidPill isPaid={data?.isPaid} />
                            <AdminActionBadge data={data} />
                            {isRefunded && <span style={{ fontSize: '10px', color: '#888', marginLeft: '4px' }}>Processed by Washta superadmin</span>}
                        </div>
                    </div>

                    <Divider style={{ margin: '0' }} />

                    <div>
                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.12em', marginBottom: '8px' }}>Service</div>
                        <div style={rowStyle}><span style={labelStyle}>Location</span><span style={valStyle}>{locationName}</span></div>
                        <div style={rowStyle}><span style={labelStyle}>Service</span><span style={{ ...valStyle, color: '#6B5FE4' }}>{data?.serviceName || data?.orderDetails?.serviceName || data?.shopId?.shopName}</span></div>
                        {(data?.serviceVariant?.variantName || data?.orderDetails?.serviceVariant?.variantName) && <div style={rowStyle}><span style={labelStyle}>Variant</span><span style={valStyle}>{data?.serviceVariant?.variantName || data?.orderDetails?.serviceVariant?.variantName}</span></div>}
                        {data?.date && <div style={rowStyle}><span style={labelStyle}>Booked at</span><span style={valStyle}>{formatDateTimeLabel(data.date)}</span></div>}
                        {data?.orderCompleteAt && <div style={{ ...rowStyle, borderBottom: 'none' }}><span style={labelStyle}>{isRefunded ? 'Refunded at' : 'Completed at'}</span><span style={valStyle}>{formatDateTimeLabel(data.orderCompleteAt)}</span></div>}
        {!data?.orderCompleteAt && data?.paidAt && <div style={{ ...rowStyle, borderBottom: 'none' }}><span style={labelStyle}>{isRefunded ? 'Refunded at' : 'Paid at'}</span><span style={valStyle}>{formatDateTimeLabel(data.paidAt)}</span></div>}
                    </div>

                    <div>
                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.12em', marginBottom: '8px' }}>Vehicle</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#f8f7ff', border: '1px solid #e8e4ff', borderRadius: '16px', padding: '12px 14px' }}>
                            <span style={{ fontSize: '24px', flexShrink: 0 }}>🚙</span>
                            <div style={{ minWidth: 0 }}>
                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111', lineHeight: 1.2 }}>
                                    {vehicleName}
                                </div>
                                <div style={{ fontSize: '11px', color: '#8b8b8b', marginTop: '2px' }}>{vehicleSubtitle}</div>
                            </div>
                            <div style={{ marginLeft: 'auto', fontSize: '12px', fontWeight: '700', background: '#fff9c4', color: '#5c4a00', border: '1px solid #ffe082', borderRadius: '8px', padding: '6px 12px', flexShrink: 0 }}>
                                {data?.vehicleId?.vehiclePlateNumber || 'PLATE'}
                            </div>
                        </div>
                    </div>

                    {isMobileService && parkingNote && (
                        <div>
                            <div style={{ fontSize: '12px', fontWeight: '700', color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.12em', marginBottom: '8px' }}>Customer Parking Info</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#fff9e6', border: '1px solid #ffe082', borderRadius: '14px', padding: '12px 14px' }}>
                                <span style={{ fontSize: '22px', flexShrink: 0 }}>🅿️</span>
                                <div>
                                    <div style={{ fontSize: '11px', fontWeight: '700', color: '#856404', textTransform: 'uppercase', letterSpacing: '.08em' }}>Parked at</div>
                                    <div style={{ fontSize: '14px', fontWeight: '700', color: '#5c4a00', marginTop: '2px' }}>{parkingNote}</div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div>
                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.12em', marginBottom: '8px' }}>What to do</div>
                        {/* <div style={rowStyle}><span style={labelStyle}>Service</span><span style={{ ...valStyle, color: '#6B5FE4' }}>{serviceName}{variantTypeLabel ? ` ${variantTypeLabel}` : ''}</span></div> */}
                          <div style={rowStyle}><span style={labelStyle}>Service</span><span style={valStyle}>{data?.serviceName || data?.orderDetails?.serviceName || 'Service'}</span></div>
                              {variantTypeLabel && <div style={rowStyle}><span style={labelStyle}>Service Type</span><span style={valStyle}>{variantTypeLabel}</span></div>}
                          {(data?.serviceVariant?.variantName || data?.orderDetails?.serviceVariant?.variantName) && <div style={rowStyle}><span style={labelStyle}>Variant</span><span style={valStyle}>{data?.serviceVariant?.variantName || data?.orderDetails?.serviceVariant?.variantName}</span></div>}
                                                {(data?.serviceVariant?.selectedVehicleType || data?.orderDetails?.serviceVariant?.selectedVehicleType) && <div style={rowStyle}><span style={labelStyle}>Selected Car Type</span><span style={valStyle}>{data?.serviceVariant?.selectedVehicleType || data?.orderDetails?.serviceVariant?.selectedVehicleType}</span></div>}

                        {addOns.map((a, i) => (
                            <div key={a?.addonId || i} style={{ ...rowStyle, borderBottom: i === addOns.length - 1 ? 'none' : '1px solid #eef0f4' }}>
                                <span style={labelStyle}>Add-on</span>
                                <span style={valStyle}>{a?.name || a?.addOnName || 'Add-on'}</span>
                            </div>
                        ))}
                    </div>

                    <div>
                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#a8a8a8', textTransform: 'uppercase', letterSpacing: '.12em', marginBottom: '8px' }}>Pricing</div>
                        <div style={{ background: '#f8f7ff', border: '1px solid #e8e4ff', borderRadius: '14px', padding: '10px 12px' }}>
                            <div style={{ ...rowStyle, padding: '5px 0' }}>
                                <span style={labelStyle}>Service price</span>
                                <span style={valStyle}>{servicePrice.toFixed(2)} AED</span>
                            </div>
                            {addOnsTotal > 0 && (
                                <div style={{ ...rowStyle, padding: '5px 0' }}>
                                    <span style={labelStyle}>Add-ons</span>
                                    <span style={valStyle}>+ {addOnsTotal.toFixed(2)} AED</span>
                                </div>
                            )}
                            {/* {discount > 0 && (
                                <div style={{ ...rowStyle, padding: '5px 0' }}>
                                    <span style={labelStyle}>Promo discount</span>
                                    <span style={{ ...valStyle, color: '#b91c1c' }}>- {discount.toFixed(2)} AED</span>
                                </div>
                            )} */}
                            {/* <div style={{ ...rowStyle, padding: '5px 0' }}>
                                <span style={labelStyle}>Washta commission ({WASHTA_COMMISSION_PERCENT}%)</span>
                                <span style={{ ...valStyle, color: '#b91c1c' }}>- {washtaCommission.toFixed(2)} AED</span>
                            </div> */}
                            <div style={{ borderTop: '1px dashed #d6d0ff', marginTop: '4px', paddingTop: '7px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '14px' }}>
                                <span style={{ fontSize: '12px', fontWeight: '700', color: '#111' }}>Total</span>
                                <span style={{ fontSize: '12px', fontWeight: '700', color: '#111' }}>{sellerReceives.toFixed(2)} AED</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', padding: '10px 20px 12px', borderTop: '1px solid #eee', background: '#f7f7f9', borderBottomLeftRadius: '28px', borderBottomRightRadius: '28px' }}>
                <button onClick={onHide} style={{ fontSize: '13px', color: '#7d7d7d', border: '1px solid #ddd', borderRadius: '12px', padding: '9px 18px', background: '#fff', cursor: 'pointer', minWidth: '96px' }}>
                    Close
                </button>
                {canAcceptRefuse && (
                    <>
                        <button
                            onClick={handleRefuse}
                            disabled={loadingAction !== null}
                            style={{ fontSize: '13px', color: '#ef4444', border: '1px solid #fca5a5', borderRadius: '12px', padding: '9px 18px', background: '#fff', cursor: 'pointer', minWidth: '96px' }}
                        >
                            {loadingAction === 'refuse' ? <CircularProgress size={15} color="inherit" /> : 'Refuse'}
                        </button>
                        <button
                            onClick={handleAccept}
                            disabled={loadingAction !== null}
                            style={{ fontSize: '13px', color: '#fff', border: 'none', borderRadius: '12px', padding: '9px 20px', background: '#6B5FE4', cursor: 'pointer', minWidth: '120px', fontWeight: '700' }}
                        >
                            {loadingAction === 'accept' ? <CircularProgress size={15} color="inherit" /> : 'Accept →'}
                        </button>
                    </>
                )}

                {canComplete && (
                    <button
                        onClick={handleMarkComplete}
                        disabled={loadingAction !== null}
                        style={{ fontSize: '13px', color: '#fff', border: 'none', borderRadius: '12px', padding: '9px 20px', background: '#6B5FE4', cursor: 'pointer', minWidth: '190px', fontWeight: '700' }}
                    >
                        {loadingAction === 'complete' ? <CircularProgress size={15} color="inherit" /> : 'Mark Complete →'}
                    </button>
                )}
            </div>
        </Dialog>
    );
};

// ── DEFAULT EXPORT — wrapper that includes modal state ─────────────────────────
const ActiveOrders = ({ Accpet, Complete, orderlocation, status, billingStatus, Refuse, data, promoCode, showMarkButton = true, onMarkComplete }) => {
    const [modalVisible, setModalVisible] = useState(false);

    return (
        <>
            <ActiveOrderCard
                data={data}
                Accpet={Accpet}
                Refuse={Refuse}
                Complete={Complete}
                billingStatus={billingStatus}
                status={status}
                orderlocation={orderlocation}
                showMarkButton={showMarkButton}
                onViewDetails={() => setModalVisible(true)}
            />

            <OrderDetailModal
                visible={modalVisible}
                onHide={() => setModalVisible(false)}
                data={data}
                billingStatus={billingStatus}
                status={status}
                orderlocation={orderlocation}
                onMarkComplete={onMarkComplete || Complete}
                onAccept={Accpet}
                onRefuse={Refuse}
            />
        </>
    );
};

export default ActiveOrders;